<template>
  <ThemedTextField
    v-model="text"
    outlined
    label="Search voyage"
    persistent-placeholder
    dense
    @input="onTextChanged(text)"
  />
</template>

<script>
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "SearchVoyageComponent",
  components: { ThemedTextField },
  data: function () {
    return {
      text: "",
    };
  },
  methods: {
    onTextChanged(text) {
      this.$store.dispatch(
        "weatherRouting/voyagesModule/filterVoyagesByDescription",
        {
          description: text,
        }
      );
    },
  },
};
</script>
